module.exports = __webpack_public_path__ + "static/media/technology.52907186.png";